import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import { Layout } from './components/Layout';
import { CreatePosting } from './components/CreatePosting/CreatePosting';
import { NotFound } from './components/NotFound';
import { SubmissionSuccess } from './components/SubmissionSuccess';
import { SubmissionError } from './components/SubmissionError';
import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import ApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import { ApplicationPaths } from './components/api-authorization/ApiAuthorizationConstants';

import './custom.css'

export default class App extends Component {
  static displayName = App.name;

  render () {
    return (
      <Layout>
        <Switch>
          {/* <Route path='/CreatePosting' component={CreatePosting}/>
          {/* <Route path='/a' component={CreatePosting} /> */}
		      {/* RJM 10/14/2020 Authorize route only takes the path parameter as return url. Need to do this for now to make it work */}
          <AuthorizeRoute path='/ClientApp/CreatePosting' component={CreatePosting} />
          <AuthorizeRoute path='/ClientApp/SubmissionSuccess' component={SubmissionSuccess} />
          <AuthorizeRoute path='/ClientApp/SubmissionError' component={SubmissionError} />
          <Route path={ApplicationPaths.ApiAuthorizationPrefix} component={ApiAuthorizationRoutes} />
          <Route component={NotFound} />
        </Switch>
      </Layout>
    );
  }
}